/**
 * Ha létezik már hibákat tartalmazó elem, akkor azt adja vissza.
 * @param id - Id.
 */
export default function getErrorsElement (id: string): HTMLElement | null {
  return document.querySelector(`#${ id }`)
}
